import styled from 'styled-components'
import { Style } from '../../styles'

// Input wrapper rendering a fixed, non-editable URL prefix in front of the slug input(s).
const UrlInput = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${Style.color.border};
  border-radius: ${Style.variables.baseBorderRadius};
  background: white;
  padding-left: ${Style.spacing.x1_5};
  overflow: hidden;

  &:focus-within {
    border-color: ${Style.color.brandPrimary};
  }

  span {
    flex-shrink: 0;
    color: #637381;
    white-space: nowrap;
  }

  input {
    border: none !important;
    box-shadow: none !important;
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
`

export default UrlInput
